import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CardModule } from '@rappi/ui/card';
import { InputModule } from '@rappi/ui/input';
import { SelectModule } from '@rappi/ui/select';
import { DatepickerModule } from '@rappi/ui/datepicker';
import { DynamicTableModule } from '@rappi/ui/dynamic-table';
import { BreadcrumbsModule } from '@rappi/ui/breadcrumbs';
import { CustomTooltipModule } from '@rappi/ui/custom-tooltip';

import { FormErrorsDirectiveModule } from '@rappi/common';

import { HasPermissionModule } from '../shared/directives/has-permissions/has-permissions.module';

import { FinancialHubRoutingModule } from './financial-hub-routing.module';
import { FinancialHubComponent } from './financial-hub.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { CompanyDetailComponent } from './components/company-detail/company-detail.component';
import { CommercialOwnersDialogComponent } from './components/commercial-owners-dialog/commercial-owners-dialog.component';
import { PurchaseOrdersComponent } from './components/purchase-orders/purchase-orders.component';
import { PurchaseOrderDetailComponent } from './components/purchase-order-detail/purchase-order-detail.component';
import { PurchaseOrderViewComponent } from './components/purchase-order-view/purchase-order-view.component';
import { PoApprovalActionsComponent } from './components/po-approval-actions/po-approval-actions.component';
import { CompanyApprovalActionsComponent } from './components/company-approval-actions/company-approval-actions.component';
import { PoActionDialogComponent } from './components/po-action-dialog/po-action-dialog.component';
import { NumericInputDirective } from './directives/numeric-input.directive';
import { PercentageDirective } from './directives/percentage.directive';
import { MakersFinancesMgrService } from './services/makers-finances-mgr.service';
import { FinancialHubAccessGuard } from './guards/financial-hub-access.guard';
import { FinancialHubDefaultSectionGuard } from './guards/financial-hub-default-section.guard';
import { CountryQueryParamGuard } from './guards/country-query-param.guard';
import { SectionGeneralInfoComponent } from './components/purchase-order-detail/sections/section-general-info/section-general-info.component';
import { SectionPoDocumentComponent } from './components/purchase-order-detail/sections/section-po-document/section-po-document.component';
import { SectionBudgetDatesComponent } from './components/purchase-order-detail/sections/section-budget-dates/section-budget-dates.component';
import { SectionBuyerInfoComponent } from './components/purchase-order-detail/sections/section-buyer-info/section-buyer-info.component';
import { SectionAdditionalInfoComponent } from './components/purchase-order-detail/sections/section-additional-info/section-additional-info.component';
import { PoConfirmDialogComponent } from './components/purchase-order-detail/po-confirm-dialog/po-confirm-dialog.component';
import { PoDocumentPreviewDialogComponent } from './components/purchase-order-detail/po-document-preview-dialog/po-document-preview-dialog.component';
import { PoInfoBannerComponent } from './components/po-info-banner/po-info-banner.component';
import { CompanyFormComponent } from './components/company-form/company-form.component';
import { CompanyFieldComponent } from './components/company-form/components/company-field/company-field.component';
import { CompanyFormSectionComponent } from './components/company-form/components/company-form-section/company-form-section.component';
import { CompanyFilesCardComponent } from './components/company-form/components/company-files-card/company-files-card.component';
import { AgencyRebatesCardComponent } from './components/company-form/components/agency-rebates-card/agency-rebates-card.component';
import { CompanyGroupDialogComponent } from './components/company-form/dialogs/company-group-dialog/company-group-dialog.component';
import { ContactFormDialogComponent } from './components/shared/contact-form-dialog/contact-form-dialog.component';
import { FhSelectComponent } from './components/shared/fh-select/fh-select.component';
import { PhoneFieldComponent } from './components/phone-field/phone-field.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    FinancialHubRoutingModule,
    MatDialogModule,
    MatTooltipModule,
    CardModule,
    InputModule,
    SelectModule,
    DatepickerModule,
    DynamicTableModule,
    BreadcrumbsModule,
    CustomTooltipModule,
    HasPermissionModule,
    FormErrorsDirectiveModule
  ],
  declarations: [
    FinancialHubComponent,
    CompaniesComponent,
    CompanyDetailComponent,
    CommercialOwnersDialogComponent,
    PurchaseOrdersComponent,
    PurchaseOrderDetailComponent,
    PurchaseOrderViewComponent,
    PoApprovalActionsComponent,
    CompanyApprovalActionsComponent,
    NumericInputDirective,
    PercentageDirective,
    SectionGeneralInfoComponent,
    SectionPoDocumentComponent,
    SectionBudgetDatesComponent,
    SectionBuyerInfoComponent,
    SectionAdditionalInfoComponent,
    PoConfirmDialogComponent,
    PoDocumentPreviewDialogComponent,
    PoActionDialogComponent,
    PoInfoBannerComponent,
    CompanyFormComponent,
    CompanyFieldComponent,
    CompanyFormSectionComponent,
    CompanyFilesCardComponent,
    AgencyRebatesCardComponent,
    CompanyGroupDialogComponent,
    ContactFormDialogComponent,
    FhSelectComponent,
    PhoneFieldComponent,
  ],
  entryComponents: [PoConfirmDialogComponent, PoDocumentPreviewDialogComponent, PoActionDialogComponent, CommercialOwnersDialogComponent, CompanyGroupDialogComponent, ContactFormDialogComponent],
  providers: [MakersFinancesMgrService, FinancialHubAccessGuard, FinancialHubDefaultSectionGuard, CountryQueryParamGuard]
})
export class FinancialHubModule {}
